import React, { Component } from 'react';
import * as StockValueAction from '../actions/StockValueAction';
import StockValueStore from '../stores/StockValueStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import ReactPaginate from 'react-paginate';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import * as MenuAction from '../actions/MenuAction';
import Button from '@material-ui/core/Button';
import swal from 'sweetalert';
import { display } from '@material-ui/system';
let currentPagePath;
class StockvalueComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            GridArray: [],
            BUArray: [],
            DropDownVal: "0",
            DropDownText: "Select",
            BUTextBoxval: "",
            IsBinLocChecked: false,
            IsQtyOnHandChecked: false,
            ColumnName: "",
            anchorEl: null,
            open: false,
            SortBy: "",
            total: "0",
            IsPageLoad: false,
            Options: [],
            totalCount: 0,
            itemCount: 10,
            pageCount: 0,
            pageNo: 1,
            DDDisplayName: "Select",
            isFavorited: false,
            GridShowBinLoc: false
        }
    }
    componentDidMount() {

        
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        StockValueAction.getCurrentFavPage(getFavPageBO);
        this.PageLoad()
        StockValueStore.on('BuData', this.PageLoadResponse);
        StockValueStore.on('GridData', this.GoClickResponse);
        StockValueStore.on('Total', this.TotalCalculate);
        StockValueStore.on('Export', this.FileExport);
        StockValueStore.on('favpage', this.loadFavPageResponse.bind(this));
        StockValueStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    componentWillUnmount() {
        StockValueStore.removeListener('BuData', this.PageLoadResponse);
        StockValueStore.removeListener('GridData', this.GoClickResponse);
        StockValueStore.removeListener('Export', this.FileExport);
        StockValueStore.removeListener('Total', this.TotalCalculate);
        StockValueStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        StockValueStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
    }
    //This Method is used to invoke the pageload method in API to get BU list
    PageLoad = () => {
        let PageLoadBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        StockValueAction.PageLoad(PageLoadBO);
    }
    //This Method is used to setstate BU list data to an array    
    PageLoadResponse = () => {
        
        let PageLoadBU = JSON.parse(StockValueStore.PageLoadData);
        let BuArraydata = PageLoadBU.Table;
        if (BuArraydata.length > 0) {
            this.setState({
                BUArray: BuArraydata, IsPageLoad: true
            });
        }
        this.BuDD();
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //This Method is used to calculate the total dollars of all the records
    TotalCalculate = () => {
        
        let total = JSON.parse(StockValueStore.Total);
        let TotalData = total.Table;
        let loctotal = 0;
        if (TotalData.length > 0) {
            TotalData.map((item, index) => {
                loctotal += parseFloat(item.EXT_COST);
            })
        }
        let formtot = parseFloat(loctotal.toFixed(2));
        loctotal = (formtot).toLocaleString('en');
        console.log("totalvalue", parseFloat(loctotal).toFixed(2));
        this.setState({ total: loctotal });

    }
    //This Method is used to dynamically bind the label and vaue for BU DropDown
    BuDD = () => {
        
        let BUValue = []
        if (this.state.BUArray.length > 0) {
            this.state.BUArray.map((val, index) => {
                //if (index == 0) {
                //    let defaultvalue = {
                //        value: index,
                //        label: "Select",
                //    }
                //    BUValue.push(defaultvalue)
                //}
                //let des = val.BUSINESS_UNIT;
                //let dessplit = des.split('-');
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCR,
                }
                BUValue.push(localArray)

            });
        }
        this.setState({ Options: BUValue });

    };
    //This Method is used to setstate the selected value from the BU Dropdown
    handleDDChange = (values) => {
        
        this.setState(
            { DropDownVal: values.value, DropDownText: values.value, BUTextBoxval: values.value, DDDisplayName: values.label });
    }
    //This Method is used to store the export to excel success message and its response
    FileExport = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let expfile = JSON.parse(StockValueStore.Excel);

    }
    //This method is used to handle the bin loc checkbox and invokes GridDataLoad method to get data
    handleBinLocChange = (checked) => {
        
        let BUTextBoxval = this.state.BUTextBoxval;
        if (this.state.BUTextBoxval == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Select The Crib ID'
            });
            //  alert('Please Select The Crib ID');
        }
        else {
            //WW-395 Stock value report is showing DEFAULT_LOC_INV; needs to show PHYSICAL_INV location - Deepthi N H
            //if (this.state.GridArray.length > 0) {
            //    let GridDataBO = {
            //        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            //        BuTextValue: BUTextBoxval,
            //        DropDownVal: this.state.DropDownVal,
            //        DropDownText: this.state.DropDownText,
            //        ColumnName: this.state.ColumnName,
            //        SortBy: this.state.SortBy,
            //        IsBinLocChecked: checked,
            //        IsQtyHandChecked: this.state.IsQtyHandChecked,
            //        PageNo: this.state.pageNo,
            //        ItemCount: this.state.itemCount
            //    }
            //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            //    StockValueAction.GridDataLoad(GridDataBO);
            //    StockValueAction.GetTotal(GridDataBO);
            //}
            this.setState({ IsBinLocChecked: checked });
        }
    }
    //This method is used to handle the Quantity On Hand = 0 checkbox and invokes GridDataLoad method to get data
    handleQtyOnHandChange = (checked) => {
        
        let BUTextBoxval = this.state.BUTextBoxval
        if (this.state.BUTextBoxval == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Select The Crib ID'
            });
            //   alert('Please Select The Crib ID');
        }
        else {
            //WW-395 Stock value report is showing DEFAULT_LOC_INV; needs to show PHYSICAL_INV location - Deepthi N H
            //if (this.state.GridArray.length > 0) {
            //    let GridDataBO = {
            //        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            //        BuTextValue: BUTextBoxval,
            //        DropDownVal: this.state.DropDownVal,
            //        DropDownText: this.state.DropDownText,
            //        ColumnName: this.state.ColumnName,
            //        SortBy: this.state.SortBy,
            //        IsBinLocChecked: this.state.IsBinLocChecked,
            //        IsQtyHandChecked: checked,
            //        PageNo: this.state.pageNo,
            //        ItemCount: this.state.itemCount
            //    }

            //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            //    StockValueAction.GridDataLoad(GridDataBO);
            //    StockValueAction.GetTotal(GridDataBO);
            //}
            this.setState({ IsQtyOnHandChecked: checked });
        }

    }
    handleBuTextChange = (e) => {
        
        this.setState({ BUTextBoxval: e.target.value });
    }
    //This Method is invoked when the User clicks on the GO Button
    GoClick = () => {
        
        //let BUTextBoxval = $('#buddid').text();
        let BUTextBoxval = this.state.BUTextBoxval;
        if (BUTextBoxval.length < 5) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select BUSINESS UNIT"
            });
            //alert("Please Select BUSINESS UNIT");
        }
        else {
            let GridDataBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                BuTextValue: BUTextBoxval,
                DropDownVal: this.state.DropDownVal,
                DropDownText: this.state.DropDownText,
                ColumnName: this.state.ColumnName,
                SortBy: this.state.SortBy,
                IsBinLocChecked: this.state.IsBinLocChecked,
                IsQtyHandChecked: this.state.IsQtyOnHandChecked,// (showed qty on hand 0 even the 'hands on qty 0' is not checked)(7/8/2022)-Aparna
                PageNo: this.state.pageNo,
                ItemCount: this.state.itemCount
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');

            StockValueAction.GridDataLoad(GridDataBO);
            StockValueAction.GetTotal(GridDataBO);
            this.setState({
                GridShowBinLoc: this.state.IsBinLocChecked, pageNo: 1,
            });
        }

    }
    //This Method is Used to store the GridData into an array
    GoClickResponse = () => {
        
        let BindGrid = JSON.parse(StockValueStore.GridData);
        let BindGridData = BindGrid.Table;
        if (BindGridData.length > 0) {
            let tc = BindGrid.Table[0].TOTAL_COUNT;

            //let  pc = Math.ceil((tc > 0 ? tc : 0);
            this.setState({
                GridArray: BindGridData,
                IsPageLoad: false,
                totalCount: tc,
                pageCount: Math.ceil((tc > 0 ? tc : 0) / this.state.itemCount)
            });

        }
        else {
            this.setState({

                GridArray: [], totalCount: 0, IsPageLoad: false
            });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    //This Method is invoked when export to excel button is clicked and invokes exportdata action method
    ExportToExcelClick = () => {
        
        let BUTextBoxval = this.state.BUTextBoxval;
        let ExcelBo = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            BuTextValue: BUTextBoxval,
            DropDownVal: this.state.DropDownVal,
            DropDownText: this.state.DropDownText,
            ColumnName: this.state.ColumnName,
            SortBy: this.state.SortBy,
            IsBinLocChecked: this.state.IsBinLocChecked,
            IsQtyHandChecked: this.state.IsQtyOnHandChecked,/*[01/12/22, PC_01,WW-332], Priyanka D*///Pass the value of the state variable IsQtyOnHandChecked*/
            PageNo: this.state.pageNo,
            ItemCount: this.state.itemCount
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        StockValueAction.ExportData(ExcelBo);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(StockValueStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        if (StockValueStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(StockValueStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(StockValueStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true//isFirstTimeLoaded
        };
        console.log("masterBO", masterBO);
        MenuAction.getMasterData(masterBO);
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Stock Value Report",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            StockValueAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            StockValueAction.deleteFavPage(deleteFavPageBO)
        }
    };

    //This Method is used to invoke the GridData method on the selection of each page
    handlePageClick = (data) => {
        
        let pageNo = data.selected + 1;
        this.setState({ pageNo: pageNo });
        //let BUTextBoxval = this.state.BUTextBoxval;
        //let GridDataBO = {
        //    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
        //    BuTextValue: BUTextBoxval,
        //    DropDownVal: this.state.DropDownVal,
        //    DropDownText: this.state.DropDownText,
        //    ColumnName: this.state.ColumnName,
        //    SortBy: this.state.SortBy,
        //    IsBinLocChecked: this.state.IsBinLocChecked,
        //    IsQtyHandChecked: this.state.IsQtyHandChecked,
        //    PageNo: pageNo,
        //    ItemCount: this.state.itemCount
        //}
        //$(`#${SDIConstants.SDILoader}`).removeClass('hide');

        //StockValueAction.GridDataLoad(GridDataBO);

    };
    //A1QA-298 Sorting issue This Method is used to sort the grid date based on the selected column and its type[5/8/2023 Pavithra R]
    sort = (Arr, indexval, nextindexval, Type) => {
        let temp = []
        let size = Arr.length
        let i, j = 0;

        if (Type == "ASC") {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) > eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        } else {
            for (i = 0; i < size; i++) {
                /* 
                 * Place currently selected element array[i]
                 * to its correct place.
                 */
                for (j = i + 1; j < size; j++) {
                    /* 
                     * Swap if currently selected array element
                     * is not at its correct position.
                     */
                    if (eval(indexval) < eval(nextindexval)) {
                        temp = Arr[i];
                        Arr[i] = Arr[j];
                        Arr[j] = temp;
                    }
                }
            }
            return Arr;
        }
    }

    //A1QA-298 Sorting issue This Method is used to sort the grid date based on the selected column and its type[5/8/2023 Pavithra R]
    SortClick = (event, sortBy, columnName) => {
        ;
        let gridArray = this.state.GridArray;
        let data = [];
        console.log("MatGrid", gridArray)
        if (sortBy == "ASC") {

            switch (columnName) {
                case "INV_ITEM_ID": {
                    data = this.sort(gridArray, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "ASC")

                    break;
                }
                case "UtilizationType": {
                    data = this.sort(gridArray, "Arr[i].CRITICAL_SPARES", "Arr[j].CRITICAL_SPARES", "ASC")

                    break;
                }
                case "Manufacturer": {
                    data = this.sort(gridArray, "Arr[i].MFG_ID", "Arr[j].MFG_ID", "ASC")

                    break;
                }
                case "Manufacturer-PartNum": {
                    data = this.sort(gridArray, "Arr[i].MFG_ITM_ID", "Arr[j].MFG_ITM_ID", "ASC")

                    break;
                }
            }

        }
        else {
            switch (columnName) {
                case "INV_ITEM_ID": {
                    data = this.sort(gridArray, "Arr[i].INV_ITEM_ID", "Arr[j].INV_ITEM_ID", "DESC")

                    break;
                }
                case "UtilizationType": {
                    data = this.sort(gridArray, "Arr[i].CRITICAL_SPARES", "Arr[j].CRITICAL_SPARES", "DESC")

                    break;
                }
                case "Manufacturer": {
                    data = this.sort(gridArray, "Arr[i].MFG_ID", "Arr[j].MFG_ID", "DESC")

                    break;
                }
                case "Manufacturer-PartNum": {
                    data = this.sort(gridArray, "Arr[i].MFG_ITM_ID", "Arr[j].MFG_ITM_ID", "DESC")

                    break;
                }

            }

        }

        this.setState({ GridArray: data });
    };
    //This Method is used to sort the grid date based on the selected column and its type
    //SortClick = (event, sortBy, columnName) => {
    //    let BUTextBoxval = this.state.BUTextBoxval;
    //    let GridDataBO = {
    //        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
    //        BuTextValue: BUTextBoxval,
    //        DropDownVal: this.state.DropDownVal,
    //        DropDownText: this.state.DropDownText,
    //        ColumnName: columnName,
    //        SortBy: sortBy,
    //        IsBinLocChecked: this.state.IsBinLocChecked,
    //        IsQtyHandChecked: this.state.IsQtyHandChecked,
    //        PageNo: this.state.pageNo,
    //        ItemCount: this.state.itemCount
    //    }
    //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');

    //    StockValueAction.GridDataLoad(GridDataBO);
    //    this.setState({ ColumnName: columnName, SortBy: sortBy });
    //};
    //This Method is used to bind the grid data
    BindGridData = () => {
        
        if (this.state.GridArray.length > 0) {
            //let PageGridData = this.state.GridArray.filter((v, i, a) => a.findIndex(t => (t.INV_ITEM_ID === v.INV_ITEM_ID)) === i)
            //console.log("filtered", this.state.PageGridData)

            return this.state.GridArray.map((value, index) => {

                let tl_cost = parseFloat(value.TL_COST).toFixed(4);
                let ext_cost = parseFloat(value.EXT_COST).toFixed(2)
                if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                    return (<React.Fragment key={index}>{value.INV_ITEM_ID != "" ? <>
                        <tr>

                            <td>{value.INV_ITEM_ID}</td>
                            {this.state.GridShowBinLoc ? < td > {value.BINLOC21}</td> : null}
                            <td>{value.DESCR254}</td>
                            <td>{value.STOREROOMTYPE != null && value.storeDESCR != null ? "Type :" + value.STOREROOMTYPE + ", Description :" + value.storeDESCR : ""}</td>
                            <td>{value.PLANNER_CD}</td>
                            <td>{value.QTY_ONHAND}</td>
                            <td>${tl_cost}</td>
                            <td>${ext_cost}</td>
                            <td>{value.CURRENCY_CD}</td>
                            {/*<td>{value.RUN_DATE_TIME}</td>*/}
                            <td>{value.MFG_ID}</td>{/*WW-440_PC_01 (7/7/2022)-Aparna**/}
                            <td>{value.MFG_ITM_ID}</td>
                            <td>{value.CRITICAL_SPARES}</td>
                            <td>{value.STD_PACK_UOM}</td>
                        </tr>
                    </> : null}
                    </React.Fragment>


                    );
                }

            })

        }
    }
    render() {
        return (
            //<div className="container-fluid content-section">
            <div className="container-fluid content-section custom-mb">
                <div className="row">
                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title"><Trans>Stock Value Report</Trans></h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-Fav" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-Fav">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 my-3">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="row">
                                    <label className="catalog-label mt-2 ml-2"><Trans>Select</Trans><span> BU</span></label>
                                    <div className="ml-2 mb-2" style={{ "fontSize": "14px", "width": "326px" }}><Select
                                        id="buddid"
                                        name="BuDD"
                                        onChange={(e) => this.handleDDChange(e)}
                                        value={{ label: this.state.DDDisplayName }}
                                        defaultValue="Select"
                                        options={this.state.Options}
                                    /></div>
                                    <div className="ml-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={this.GoClick}><Trans>GO</Trans></button>
                                    </div>
                                    {this.state.GridArray.length > 0 ?
                                        <div className="ml-2">
                                            <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={() => this.ExportToExcelClick()}><Trans>Export to Excel</Trans></button>

                                        </div> : null}
                                </div>
                                <div className="my-3">
                                    <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block mr-4" >
                                        <input type="checkbox" className="custom-control-input" id="binlocid" name="example4" checked={this.state.IsBinLocChecked} onChange={() => this.handleBinLocChange(!this.state.IsBinLocChecked)} />
                                        <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor="binlocid"><Trans>Show Bin Loc</Trans></label>
                                    </div>
                                    <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block">
                                        <input type="checkbox" className="custom-control-input" id="qtyonhandid" name="example4" checked={this.state.IsQtyOnHandChecked} onChange={() => this.handleQtyOnHandChange(!this.state.IsQtyOnHandChecked)} />
                                        <label className="custom-control-label priority-checkbox profile-update-checkbox" htmlFor="qtyonhandid"><Trans>Include Quantity On Hand</Trans><span> = 0</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <label className="catalog-label mt-2 mr-3">Utilization Type :</label>
                        <div className="my-2 mb-2" style={{ "fontSize": "14px" }}>
                            A: 90 <Trans>Days</Trans><span> </span>
                            B: 180 <Trans>Days</Trans><span> </span>
                            C: 365 <Trans>Days</Trans><span> </span>
                            CS:30 <Trans>Days</Trans><span> </span>
                            D: <Trans>Not</Trans><span> </span><Trans>Counted</Trans><span> </span>
                        </div>
                    </div>

                    <div className="col-md-6 text-right pb-4">
                        <div className="my-2" style={{ "fontSize": "17px" }}>
                            Total:&nbsp; $&nbsp;{this.state.total}
                        </div>
                    </div>

                    {this.state.GridArray.length > 0 ?
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                    <thead>
                                        <tr>

                                            <th className="position-sort-icon" style={{ "width": "20px" }}><Trans>Item ID</Trans><span className="sort-up1 ml-1 mb-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "INV_ITEM_ID")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "INV_ITEM_ID")} /></span></th>
                                            {this.state.GridShowBinLoc ? <th className="d-sm-none d-md-table-cell" style={{ "width": "15px" }}><Trans>Bin</Trans><span> </span><Trans>Location</Trans></th> : null}
                                            <th className="d-md-table-cell" style={{ "width": "40px" }}><Trans>ItemKey</Trans><span> </span><Trans>Description</Trans></th>
                                            <th className="d-md-table-cell " style={{ "width": "10px" }}><Trans>Store Room</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Planner CD</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><span>Qty </span><Trans>On Hand</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><span>Wt Avg </span><Trans>Cost</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Extended Cost</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "5px" }}><Trans>Currency</Trans></th>
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "5px" }}><Trans>MFG</Trans><span className="sort-up1 ml-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "Manufacturer")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "Manufacturer")} /></span></th>{/*WW-440_PC_02 (7/7/2022)-Aparna**/}
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "5px" }}><Trans>MFG Part#</Trans><span className="sort-up1 ml-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "Manufacturer-PartNum")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "Manufacturer-PartNum")} /></span></th>
                                            {/*<th className="d-none d-sm-none d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><span>Time </span><span className="sort-up1 ml-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "RUN_DATE_TIME")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "RUN_DATE_TIME")} /></span></th>*/}
                                            <th className="d-md-table-cell position-sort-icon" style={{ "width": "10px" }}><Trans>Utilization Type</Trans><span className="sort-up1 ml-1"><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "UtilizationType")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "UtilizationType")} /></span></th>
                                            <th className="d-md-table-cell " style={{ "width": "5px" }}>UOM</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <Popover
                                            anchorEl={this.state.anchorEl}
                                            open={this.state.open}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                        >
                                            <Typography >The content of the Popover.</Typography>
                                        </Popover>
                                        {this.BindGridData()}
                                    </tbody>
                                </table>
                                {this.state.totalCount > 0 ?
                                    <div className="col-md-12 ">
                                        <span className="total-records mt-2 d-inline-block">
                                            <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                        </span>
                                        {this.state.totalCount > this.state.itemCount ? <ReactPaginate
                                            previousLabel={<span className="right-pagination-arrow" />}
                                            nextLabel={<span className="left-pagination-arrow" />}
                                            previousClassName={'page-item'}
                                            nextClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextLinkClassName={'page-link'}
                                            disabledClassName={'disabled'}
                                            breakLabel={'...'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'custom-pagination pagination float-right'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                            hrefBuilder={() => '#'}
                                            forcePage={this.state.pageNo - 1}
                                        /> : null}

                                    </div> : null}
                            </div>
                        </div> : this.state.IsPageLoad == false ? (<section className="site-undercontruction container text-center center-panel pt-4">
                            <div className="img-section">
                                <img src="images/nosearch.jpg" alt="imagefile" />
                            </div>
                            <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                            </p>
                        </section>) : null}

                </div>
            </div>
        );
    };
}
export default withTranslation()(StockvalueComponent);